<template>
    <div>
        <vx-card title="Painel Geral de Desenvolvimento" :badge="items_showed" refresh-content-action download-card-action
        @refresh="getTickets('')" @download="function(){
                        csv = true
                        $nextTick(() => {
                            csv = false
                        })
                    }"
        >
            <vs-col slot="nav"  vs-type="flex" vs-justify="flex-end" vs-w="12">
                <i-input search @input="searchDelay" placeholder="Pesquisar" size="large" ></i-input>
                <div v-if="isTester" class="py-2 ml-2">
                    <i-switch v-model="filtro.testOnly"></i-switch>
                </div>
            </vs-col>
            <div>
                 <TableDraggable :csv="csv" :columns="pgd_colunas" :data-items="ticketsFiltro" :defaultOrder="{ key: 'posicao', dir: 'asc'}"
                        :dragDisabled="!permissoes.arrastar()"
                        dragWithFilter listKey="id_ticket" :offsetTop="290"
                        @dataUpdated="onListUpdate" @drop="onDrop" dragByColumn="tipo_id"
                        lock-axis="y" ref="tableDraggable"></TableDraggable>
                <DrawerTicket v-model="edit_pgd" :id="edit_id" @update="onTicketUpdate"></DrawerTicket>
                <!-- componete para descrever a alteração do andamento
                    @param andamento dados do ticket em alteração
                    @ref button para ter acesso nas variveis do comeponete filho
                    @value show_andamento para exibir o componete
                    @emit chama uma função parta tratar os dados recebidos
                -->
                <DrawerAndamento ref="drawer" :andamento="andamento" v-model="show_andamento"
                                v-on:update="updateAndamento">
                </DrawerAndamento>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {req as reqMixin, ticket as ticketMixin} from '../../mixins';

    import _ from "lodash";
    import {moment} from "../../helpers/utils.js";

    export default {
        name: "tickets-pgds",
        mixins: [reqMixin, ticketMixin],
        components: {
            DrawerTicket: () => import("./components/Drawer.vue"),
            DrawerAndamento: () => import("./components/drawer-pgd-form-causas.vue")
        },
        data() {
            return {
                filtro: {
                    search: "",
                    testOnly: false,
                },
                edit_pgd: false,
                edit_id: 0,
                items_showed: 0,
                tempos_bug: {},
                pgd_colunas: [
                    {
                        title: "Tipo",
                        width: 95,
                        key: "tipo_id",
                        render: (h, params) => {
                            return h("span", {
                                attrs: {
                                    class: "content-column"
                                }
                            }, [
                                h("Icon", {
                                    props: {
                                        ...this.getIconPgd(params.row.tipo_id, params.row.criticidade || 0)
                                    },
                                    style: {
                                        fontSize: "35px"
                                    }
                                }),
                                params.row.sistema_nome || "",
                            ]);
                        },
                        filters: [
                            {
                                label: "Bug",
                                value: 32
                            },
                            {
                                label: "Melhoria",
                                value: 33
                            },
                            {
                                label: "SS",
                                value: 35
                            },
                            {
                                label: "MVP",
                                value: 45
                            }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.tipo_id == value;
                        }
                    },
                    {
                        title: "",
                        key: "id_ticket",
                        width: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h({
                                template: ` <span class="content-column">
                                                <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                                    <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                                </Tooltip>
                                                <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                                    <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                                </Tooltip>
                                            </span>`
                            });
                        }
                    },
                    {
                        title: "Atribuido a",
                        key: "atribuido_a_nome",
                        width: 150,
                        sortable: true,
                        filters: this.analistas,
                        filterMultiple: false,
                        render: (h, params) => {
                            return h("span", [
                                params.row.atribuido_a_nome
                                    ? params.row.atribuido_a_nome.replace(/ .*/, "")
                                    : "",
                                h("DropdownList", {
                                    attrs: {
                                        id: params.row.id_ticket,
                                        onSelect: this.atribuirTicket,
                                        list: this.analistas_atribuicao
                                    }
                                })
                            ]);
                        },
                        filterMethod(value, row) {
                            return row.atribuido_a_id == value;
                        }
                    },
                    {
                        title: "Resumo",
                        key: "resumo",
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ],
                                    ),
                                    h("div",{
                                        style: {
                                            fontSize: "12px"
                                        }
                                    },params.row.projeto_nome),
                                ],
                            );
                        }
                    },
                    {
                        title: " ",
                        width: 150,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-around"
                                    }
                                },
                                [
                                    h("PgdTimeline", {
                                        attrs: {
                                            id: params.row.id_ticket,
                                            total: params.row.timeline_count
                                        }
                                    }),
                                    h("Icon", {
                                        props: {
                                            type:
                                                params.row.tela_ux == 1
                                                    ? "ios-color-palette"
                                                    : "ios-color-palette-outline"
                                        },
                                        style: {
                                            fontSize: "22px",
                                            color: "#515a73",
                                            display: "block"
                                        }
                                    }),
                                    h("PgdAssociacoes", {
                                        attrs: {
                                            ac: parseInt(
                                                params.row.associacoes_count
                                            )
                                        }
                                    }),
                                    h("PgdGit", {
                                        props: {
                                            git: params.row.git
                                        }
                                    })
                                ]
                            );
                        }
                    },
                    {
                        title: "Criticidade",
                        width: 150,
                        key: "criticidade",
                        sortable: true,
                        render: (h, params) => {
                            if (params.row.tipo_id == 32 || params.row.tipo_id == 35 ) {
                                let prazo = moment(params.row.data_hora_aprovado).add(params.row.horas_desenvolvimento, 'hours');
                                return h("div", {
                                    class: "content-column"
                                },
                                [
                                    h("span", {
                                        class: {
                                            'font-bold': params.row.criticidade == 3,
                                            'text-red-dark': params.row.criticidade == 3,
                                        }
                                    },
                                        `${
                                        params.row.criticidade ==1 ? "BAIXA" :
                                            params.row.criticidade == 2 ? "MÉDIA" :
                                                params.row.criticidade ==3 ? "ALTA": ""}`),
                                    h("Tooltip", {
                                        props: {
                                            placement: "top",
                                            content: `Prazo: ${prazo.format("DD/MM/YYYY H:mm")}`,
                                        }
                                    },
                                    [
                                        h("Countdown", {
                                            attrs: {
                                                class: 'font-bold',
                                            },
                                            props: {
                                                date: prazo,
                                                format: "digital"
                                            }
                                        })
                                    ])
                                ]);
                            } else {
                                let prazo = moment(params.row.data_hora_pgd).add(params.row.horas_desenvolvimento, 'hours');
                                return h("div", {
                                    class: "content-column"
                                },
                                [
                                    h("Tooltip", {
                                        props: {
                                            placement: "top",
                                            content: `Prazo: ${prazo.format("DD/MM/YYYY H:mm")}`,
                                        }
                                    },
                                    [
                                        h("Countdown", {
                                            attrs: {
                                                class: 'font-bold',
                                            },
                                            props: {
                                                date: prazo,
                                                format: "digital"
                                            }
                                        })
                                    ])
                                ]);
                            }
                        },
                        filters: [
                            {
                                label: "Alta",
                                value: 3
                            },
                            {
                                label: "Média",
                                value: 2
                            },
                            {
                                label: "Baixa",
                                value: 1
                            }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.criticidade == value && row.tipo_id == 32;
                        }
                    },
                    {
                        title: "Andamento",
                        key: "andamento",
                        width: 158,
                        sortable: true,
                        render: (h, params) => {
                            return h("PgdAndamento", {
                                props: {
                                    id: params.row.id_ticket,
                                    andamento: params.row.andamento || 0,
                                    onSelect: this.andamentoTicket
                                }
                            });
                        }
                    },
                    {
                        title: "Tempo aberto",
                        key: "data_hora_cadastro",
                        width: 166,
                        sortable: true,
                        align: "right",
                        render: (h, params) => {
                            return h("span", {
                                attrs: {
                                    class: "content-column"
                                }
                            }, [
                                h("div", moment(params.row.data_hora_cadastro).fromNow(true)),
                                h("div", {style: {fontSize: "11px"}}, moment(params.row.data_hora_cadastro).format("DD/MM/YYYY"))
                            ]);
                        }
                    },
                    {
                        title: " ",
                        width: 50,
                        render: (h, params) => {
                            const rel_id = params.row.relatado_por_id;
                            const dev_id = params.row.atribuido_a_id;
                            if (!(this.permissoes.resolver() || this.permissoes.fechar() || this.permissoes.associar() || rel_id == this.idUser || dev_id == this.idUser)) {
                                return;
                            }
                            return h("VxOptions", {
                                attrs: {
                                    id: params.row.id_ticket,
                                    onSelect: this.opcaoTicket,
                                    options: [
                                        {
                                            icone: "md-close",
                                            label: "Fechar",
                                            textColor: "#ff5252",
                                            show: true,
                                        },
                                        {
                                            icone: "md-checkmark-circle-outline",
                                            label: "Resolver",
                                            textColor: "#00bfa5",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-git-merge",
                                            label: "Associar",
                                            textColor: "#00bcd4",
                                            show: true,
                                        }
                                    ].filter(item => {
                                        if (item.label === "Resolver") {
                                            if (this.permissoes.resolver() || dev_id == this.idUser) {
                                                return item;
                                            }
                                        } else if (item.label === "Fechar" && params.row.tipo_id !== 45) {
                                            /**
                                             * MVP só podem ser resolvidos
                                             */
                                            if (this.permissoes.fechar() || rel_id == this.idUser || dev_id == this.idUser) {
                                                return item;
                                            }
                                        } else if (item.label === "Associar" && params.row.tipo_id !== 45 && !(params.row.andamento >= 1 || params.row.associacoes_count > 0)) {
                                            /**
                                             * Tickets em andamento não podem ser associados
                                             */
                                            if (this.permissoes.associar()) {
                                                return item;
                                            }
                                        }
                                    })
                                }
                            });
                        }
                    }
                ],
                tickets: [],
                analistas: [],
                show_andamento:false,
                andamento:{
                    id:null,
                    titulo:null,
                    descricao:null,
                    causa_titulo:null,
                    tipo_id:null,
                    sistema_id:null,
                    funcionalidade:null,
                },
                csv:false,
            };
        },
        computed: {
            ...mapGetters(['idUser', 'roleUser', 'isTester']),
            ticketsFiltro() {
                return this.filtro.testOnly ? this.tickets.filter(t => t.andamento > 2) : this.tickets;
            },
            analistas_atribuicao() {
                /**
                 * Permissão: Administração pode atribuir qualquer pessoa
                 */
                if ([1, 2].includes(this.roleUser)) {
                    return this.analistas;
                }
                /**
                 * Permissão: Usuário só pode atribuir a si mesmo
                 */
                return this.analistas.filter(
                    analista =>
                        analista.value == this.idUser ||
                        analista.value === -1
                );
            },
            permissoes() {
                return {
                    arrastar: () => {
                        /**
                         * Permissão: Administração
                         */
                        return [1, 29, 34].includes(this.roleUser);
                    },
                    associar: () => {
                        /**
                         * Permissão: Administração
                         */
                        return [1, 29, 34].includes(this.roleUser);
                    },
                    resolver: () => {
                        /**
                         * Permissão: Administração, Suporte e Testers
                         */
                        return [1, 7, 8, 9, 10, 11, 12, 29, 34].includes(this.roleUser);
                    },
                    fechar: () => {
                        /**
                         * Permissão: Administração e Testers
                         */
                        return [1, 7, 8, 9, 29, 34].includes(this.roleUser);
                    }
                }
            },
        },
        methods: {
            searchDelay: _.debounce(function (val) {
                if (this.filtro.search !== val) {
                    this.filtro.search = val;
                    this.getTickets(val, 1);
                }
            }, 1000),
            /**
             * Método que permite reordenar os tickets de acordo com o arraste
             */
            onDrop({removedIndex, addedIndex, payload}) {
                if (removedIndex === null || addedIndex === null) return;
                /**
                 * Caso o ticket tenha sido filtrado, tem que buscar os indices originais para serem atualizados
                 * deve ser utilizado a propriedade dragWithFilter e o listKey no table-draggable
                 */
                if (this.filtered_items && this.filtered_items.length !== this.tickets.length) {
                    const ticketRemoved = this.filtered_items[removedIndex];
                    removedIndex = _.findIndex(this.tickets, o => o.id_ticket === ticketRemoved.id_ticket);
                    const ticketAdded = this.filtered_items[addedIndex];
                    addedIndex = _.findIndex(this.tickets, o => o.id_ticket === ticketAdded.id_ticket);
                }
                const arr = this.tickets;

                let result = [...arr];
                let itemToAdd = payload;

                itemToAdd = result.splice(removedIndex, 1)[0];
                /**
                 * Atualiza a posição dos tickets no Banco de Dados
                 */
                const id_ticket = itemToAdd.id_ticket;
                const pos_atual = parseInt(itemToAdd.posicao);
                const pos_nova = parseInt(arr[addedIndex].posicao);
                this.atualizarPosicaoDB(id_ticket, pos_nova, pos_atual);
                result = this.atualizarPosicao(result, pos_nova, pos_atual);
                itemToAdd.posicao = pos_nova;
                result.splice(addedIndex, 0, itemToAdd);
                this.tickets = result;
            },
            atualizarPosicao(arr, pos_nova, pos_atual) {
                return arr.map(item => {
                    if (pos_nova > pos_atual) {
                        item.posicao -=
                            item.posicao > pos_atual && item.posicao <= pos_nova
                                ? 1
                                : 0;
                    } else {
                        item.posicao +=
                            item.posicao < pos_atual && item.posicao >= pos_nova
                                ? 1
                                : 0;
                    }
                    return item;
                });
            },
            async atualizarPosicaoDB(id_ticket, pos_nova, pos_atual) {
                try {
                    const URI = `ticket/${id_ticket}/atualizarPosicao`;
                    await this.$axios.put(URI, {
                        pos_nova,
                        pos_atual
                    });
                } catch (error) {
                    console.warn(error);
                }
            },
            getTickets(query) {
                this.$Spin.show();

                const { source, token } = this.newReq();

                const URI = `ticket/desenvolvimento?query=${query}&sort=posicao&dir=asc`;
                this.$axios
                    .get(URI, {
                        cancelToken: source.token,
                        headers: {cancelToken: token}
                    })
                    .then(({data}) => {
                        const tickets = data.map(ticket => {
                            ticket.atribuido_a_id = ticket.atribuido_a_id || -1;
                            ticket._filterChecked = null;
                            return ticket;
                        });
                        this.tickets = tickets;
                        this.$Spin.hide();
                    })
                    .catch(ex => {
                        if (this.$axios.isCancel(ex)) {
                            const {message: token} = ex;
                            this.$axios.put(`transaction/${token}`);
                        } else {
                            console.warn(ex);
                            this.$Spin.hide();
                        }
                    });
            },
            getIconPgd: (id, criticidade) => {
                const icons = {
                    32: "ios-bug",
                    33: "ios-star",
                    35: "ios-settings",
                    45: "ios-flash"
                };

                const colors = {
                    32: ["#F2ABAB", "#F2ABAB", "#E65757", "#D90000"],
                    33: ["#FFE8B6", "#FFE8B6", "#FFD06D", "#FFB822"],
                    35: ["#097BD0", "#097BD0", "#36A3F7", "#ABDAFC"],
                    45: ["#C8CDF4", "#C8CDF4", "#919BE9", "#5867DD"],
                };

                return {
                    type: icons.hasOwnProperty(id) ? icons[id] : "",
                    color: colors.hasOwnProperty(id) ? colors[id][criticidade] : "#36A3F7",
                }
            },
            /**
             * Abre o drawer para edição do ticket
             */
            editTicket(id_ticket) {
                this.edit_id = id_ticket;
                this.edit_pgd = true;
            },
            /**
             * Após editar o ticket, atualizo os dados do ticket na lista de tickets
             */
            onTicketUpdate(ticket) {
                const idx = _.findIndex(
                    this.tickets,
                    o => o.id_ticket == ticket.id_ticket
                );

                if (ticket.status == 1) {
                    this.tickets.splice(idx, 1, ticket);
                } else {
                    this.tickets.splice(idx, 1);
                }
            },
            async getTempos() {
                const {data} = await this.$axios.get('configuracoes/slatime');

                this.tempos_bug = data.reduce((acc, cur) => {
                    acc[cur.id] = cur.tempo;
                    return acc;
                }, {});
            },
            /**
             * Busca os analistas do sistema para o campo responsável do formulário
             */
            async getAnalistas() {
                try {
                    const URI = `pessoa`;
                    const {data} = await this.$axios.get(URI);
                    /**
                     * Cria um array de objetos relacionando id como chave para o nome
                     */
                    let analistas = data.map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                    analistas.unshift({
                        value: -1,
                        label: "Não atribuído"
                    });
                    this.analistas = analistas;
                    this.pgd_colunas[2].filters = analistas;
                } catch (error) {
                    console.warn(error);
                }
            },
            /**
             * Atribui o ticket para um analista desenvolver
             */
            atribuirTicket(id_ticket, id_programador) {
                const idx_tkt = _.findIndex(
                    this.tickets,
                    o => o.id_ticket == id_ticket
                );
                const idx_prog = _.findIndex(
                    this.analistas,
                    o => o.value == id_programador
                );
                /**
                 * Bloqueia a atribuição caso o ticket já esteja em andamento
                 */
                if (this.tickets[idx_tkt].andamento > 1) {
                    this.$Message.info(`O ticket já está sendo desenvolvido`);
                    return;
                }
                /**
                 * Não permite atribuir duas vezes para a mesma pessoa
                 */
                if (this.tickets[idx_tkt].atribuido_a_id == id_programador) {
                    this.$Message.warning(`Opção inválida`);
                    return;
                }
                this.tickets[idx_tkt].atribuido_a_id = id_programador;

                // Ticket não atribuído (Remove atribuíção)
                id_programador = id_programador === -1 ? null : id_programador;

                this.tickets[idx_tkt].atribuido_a_nome = id_programador
                    ? this.analistas[idx_prog].label
                    : "";
                this.tickets[idx_tkt].andamento = id_programador ? 1 : 0;
                this.alterarAtribuicao(id_ticket, id_programador);
            },
            /**
             * Grava no BD a atribuição
             */
            async alterarAtribuicao(id, id_programador) {
                const idx = _.findIndex(this.tickets, o => o.id_ticket == id);
                try {
                    const URI = `ticket/${id}/atribuir`;
                    const {data} = await this.$axios.put(URI, {
                        id_programador
                    });
                    /**
                     * Atualiza os dados do ticket na listagem
                     */
                    this.tickets.splice(idx, 1, data.ticket);
                } catch (error) {
                    console.warn(error);
                    this.$Message.error(`Erro! ${error}`);
                    this.getTickets(this.filtro.search);
                }
            },
            andamentoTicket(id, opcao) {
                const idx = _.findIndex(this.tickets, o => o.id_ticket == id);
                const ticket = this.tickets[idx];
                /**
                 * Verifica se o ticket está atribuido à alguém
                 */
                if (!ticket.atribuido_a_id || ticket.atribuido_a_id === -1) {
                    this.$Message.info(
                        `Atribua o ticket para alterar o andamento!`
                    );
                    return;
                }
                /**
                 * Verifica se o ticket é do usuário, ou se tem permissão para alterar o andamento
                 */
                if (!(this.permissoes.fechar() || ticket.atribuido_a_id == this.idUser)) {
                    this.$Message.warning(`Alteração de andamento não permitida`);
                    return;
                }

                /**
                 * Não permite atribuir se tiver telas à serem desenvolvidas
                 */
                if (
                    opcao == 2 &&
                    ticket.tela_ux == 1 &&
                    ticket.tela_ux_anexos == null
                ) {
                    this.$Message.info(
                        `Ainda não há telas desenvolvidas para este Ticket.`
                    );
                    return;
                }

                /**
                 * Não permite atribuir se tiver telas à serem desenvolvidas
                 */
                if (opcao == 2 && parseInt(ticket.horas_desenvolvimento) < 1) {
                    this.$Message.info(
                        `Defina com o owner o tempo de desenvolvimento.`
                    );
                    return;
                }

                /**
                 * Verifica se o usuário está pulando um passo no andamento
                 */
                if (
                    opcao == ticket.andamento ||
                    opcao > ticket.andamento + 1 ||
                    opcao < ticket.andamento - 2
                ) {
                    this.$Message.warning(`Alteração de andamento não permitida`);
                    return;
                }

                if (opcao == 2 && opcao < ticket.andamento) {
                    this.retrocederAndamento(id);
                } else if (opcao == 3 && opcao > ticket.andamento) {
                    this.colocarEmTestes(id);
                } else {
                    this.alterarAndamento(id, opcao);
                }
            },
            async alterarAndamento(id, andamento) {
                try {
                    const idx = _.findIndex(this.tickets, o => o.id_ticket == id);

                    const data = await this.ticketAndamento(id, andamento);

                    this.tickets[idx].andamento = andamento;

                    if (data.hasOwnProperty("git") && data.git) {
                        this.gitMessage(data.git);
                    }
                    /**
                     * Atualiza os dados do ticket na listagem
                     */
                    if (data.hasOwnProperty("ticket") && data.ticket) {
                        this.tickets.splice(idx, 1, data.ticket);
                    }
                } catch (e) {
                    console.warn(e);
                    this.$Message.error(`Erro! ${e}`);
                }
            },
            /**
             * Exibe um Modal com os dados do ticket caso tenha Git
             */
            gitMessage(git) {
                let message = "";
                switch (git.status) {
                    case 0:
                        message = `
						<p>Repositório: ${git.repo}</p><p>Branch: ${git.nome}</p>`;
                        break;
                    case 1:
                        message = `Mesclado na Branch Staging`;
                        break;
                    case 2:
                        message = `
						<p>Pull Request: <a href="${git.pr_url}" target="_blank">${git.pr_url}</a></p>`;
                        break;
                    case 3:
                        message = "";
                        break;
                }
                this.$Modal.info({
                    title: "Git",
                    content: message,
                    okText: "Ok"
                });
            },
            /**
             * Quando altera o andamento para o estágio de Analise de Qualidade,
             * o programador tem que informar o que foi desenvolvido
             */
            async colocarEmTestes(id) {
                this.edit_id = _.findIndex(this.tickets, o => o.id_ticket === id)
                const ticket = this.tickets[this.edit_id ]
                this.andamento.titulo = `Ticket ${ticket.id_ticket}`
                this.andamento.descricao = `Descrição Técnica`
                this.show_andamento = true
                this.andamento.id = 3
                this.andamento.tipo_id = ticket.tipo_id
            },
            /**
             * Quando o ticket não passa no teste, o tester tem que informar o motivo
             */
            async retrocederAndamento(id) {
                this.edit_id = _.findIndex(this.tickets, o => o.id_ticket === id)
                const ticket = this.tickets[this.edit_id ]
                this.andamento.titulo = `Tester ${ticket.id_ticket}`
                this.andamento.causa = `Motivos da desaprovação`
                this.show_andamento = true
                this.andamento.id = 2
                this.andamento.tipo_id = ticket.tipo_id
            },

            async opcaoTicket(id, opcao) {
                this.edit_id = _.findIndex(this.tickets, o => o.id_ticket === id)
                const ticket = this.tickets[this.edit_id]
                this.andamento.tipo_id = null
                this.andamento.funcionalidade = ticket.funcionalidade
                if (opcao === "Fechar") {
                    this.show_andamento = true
                    this.andamento.titulo = `Fechando Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`
                    this.andamento.descricao = `Observação`
                    this.andamento.id = 8
                } else if (opcao === "Resolver") {
                    this.show_andamento = true
                    this.andamento.titulo = `Resolvendo Ticket ${id} (${ticket.resumo.substring(0, 15)}...)`
                    this.andamento.descricao = `Observação`
                    this.andamento.sistema_id = ticket.sistema_id
                    this.andamento.id = 7
                } else if (opcao === "Associar") {
                    const {id_associado} = await this.associarTicket(ticket);
                    const idx_ass = _.findIndex(this.tickets, o => o.id_ticket === id_associado);
                    if (idx_ass !== -1) {
                        this.tickets[idx_ass].associacoes_count += 1;
                    }
                }
            },

            /**
              Quando o ticket passar por alteração no andamento é feito um update nas informações
            */
            async updateAndamento(form){
                const id = this.edit_id
                const ticket = this.tickets[id]
                if (this.andamento.id == 2){
                    try {
                        await this.ticketNaoAprovado(ticket,form)
                        this.tickets[id].andamento = 2
                    } catch (error) {
                        console.warn(error)
                        this.$Message.error(`Erro! ${error}`)
                    }
                } else {
                    if(this.andamento.id == 3){
                        try {
                            await this.ticketEmTestes(ticket,form)
                            this.tickets[id].andamento = 3
                        } catch (error) {
                            console.warn(error)
                            this.$Message.error(`Erro! ${error}`)
                        }
                    } else {
                        if(this.andamento.id == 8){
                            try {
                                await this.fecharTicket(ticket,form)
                                if (id) {
                                    this.tickets.splice(id, 1)
                                } else {
                                    this.tickets.shift()
                                }
                            } catch (error) {
                                console.warn(error);
                                this.$Message.error(`Erro! ${error}`)
                            }
                        } else {
                            if(this.andamento.id == 7){
                                try {
                                    await this.resolverTicket(ticket,form)
                                    if (id) {
                                        this.tickets.splice(id, 1)
                                    } else {
                                        this.tickets.shift()
                                    }
                                } catch (error) {
                                    console.warn(error);
                                    this.$Message.error(`Erro! ${error}`)
                                }
                            }
                        }
                    }
                }
            },

            /**
             * Exibe a quantidade de itens que estão sendo filtrados
             */
            onListUpdate(data) {
                this.filtered_items = data;
                this.items_showed = data.length;
            },
        },
        created() {
            this.getTempos();
            this.getAnalistas();
            this.getTickets("");
        }
    };
</script>
